// dateFields.ts — the source of truth for which fields are dates.
// Confirm the full list with backend; add to this set as new date fields appear.
export const DATE_FIELDS = new Set([
  "InvoiceDate",
  "DueDate",
  "PaymentDate",
]);

// Backend sends dates as "M/D/YYYY h:mm:ss AM/PM" (e.g. "9/21/2024 12:00:00 AM").
// We only need the date part, and want to avoid relying on new Date() to
// correctly parse that ambiguous format across browsers — so extract the
// date portion directly instead of round-tripping through Date parsing.
const stripTimeFromDateString = (value: string): string => {
  const [datePart] = value.split(" "); // "9/21/2024 12:00:00 AM" -> "9/21/2024"
  return datePart || value;
};

export const formatFieldValue = (
  fieldName: string,
  value: string | number | null
): string | number | null => {
  if (value === null || value === undefined || value === "") return value;

  if (DATE_FIELDS.has(fieldName) && typeof value === "string") {
    return stripTimeFromDateString(value);
  }

  return value;
};